<template>
  <div class="formGroup">
    <div class="quantity">
      <button type="button" class="btnQuantity" data-quantity="minus" disabled>-</button>
      <input type="text"
        class="inputQuantity"
        :placeholder="`${itemSetting.action.min} ~ ${itemSetting.action.max}`"
        :value="itemSetting.action.min"
        disabled>
      <button type="button" class="btnQuantity" data-quantity="plus" disabled>+</button>
    </div>
    <div v-if="itemSetting.action.price.isPrice" class="notranslate price">
      {{priceFormat(itemSetting.action.price.value)}}
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'QuantityModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  computed: {
    currencyCode () {
      return this.$store.getters['setting/getCurrencyCode'].toUpperCase()
    }
  },
  methods: {
    priceFormat (price) {
      const code = this.currencyCode
      const disabledSymbol = this.$store.getters['setting/getData']?.currency?.disabledCurrencySymbol ?? false
      return regExp.priceFormat(price, code, disabledSymbol)
    }
  }
}
</script>
